export const EXPAND_ACCORDION_EVENT_NAME = 'EXPAND_ACCORDION_EVENT';
